<template>
    <div class="navigation">
        <ul>
            <li v-for="item in navigation" :key="item.title">
                <router-link v-if="item.page"
                    :to="{
                    name: item.page,
                    params: item.params
                    }"
                >&nbsp{{ $store.getters.t( item.title ) }}</router-link>
                <template v-else>&nbsp{{ $store.getters.t( item.title ) }} </template>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        navigation: {
            type: Array,
            required: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/widgets/BreadCrumbs.vue